import { createSelector } from '@reduxjs/toolkit';

import type { CoreRootState } from '../../CoreStore';
import { selectIsMultiVideoStreaming } from '../video/rawSelectors';

export const selectIsStreamEnabled = createSelector(
  [
    (state: CoreRootState): boolean => state.settings.stream.isEnabled,
    (state: CoreRootState): boolean => state.settings.stream.isEnabledBySystem,
  ],
  (isEnabled, isEnabledBySystem) => isEnabled && isEnabledBySystem
);

export const selectIsStudioChannelEnabled = createSelector(
  [selectIsStreamEnabled, selectIsMultiVideoStreaming],
  (isStreamEnabled, isMultiVideoStreaming) => {
    return isStreamEnabled && !isMultiVideoStreaming;
  }
);
